import { render, staticRenderFns } from "./TrainingPhotos.vue?vue&type=template&id=6c2fa62a&scoped=true&"
import script from "./TrainingPhotos.vue?vue&type=script&lang=js&"
export * from "./TrainingPhotos.vue?vue&type=script&lang=js&"
import style0 from "./TrainingPhotos.vue?vue&type=style&index=0&id=6c2fa62a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c2fa62a",
  null
  
)

export default component.exports